const hasApprovals = record =>
  Boolean(record.approval_manifest && record.approval_manifest.id);

const isUserAnApprover = (record, userId) => {
  return hasApprovals(record)
    ? Boolean(
        record.approval_manifest.all_approvers.find(a => a.user_id === userId)
      )
    : false;
};

const isUserACurrentApprover = (record, userId) => {
  return hasApprovals(record)
    ? Boolean(
        record.approval_manifest.current_approvers.find(
          a => a.user_id === userId
        )
      )
    : false;
};

const getUserAsApprover = (record, userId) => {
  return hasApprovals(record)
    ? record.approval_manifest.all_approvers.find(a => a.user_id === userId)
    : null;
};

const getApprovalStatus = record => {
  return hasApprovals(record) ? record.approval_manifest.status : null;
};

const getCurrentApprovers = record => {
  return hasApprovals(record) ? record.approval_manifest.current_approvers : [];
};

const isReviewed = record =>
  ["approved", "rejected"].includes(getApprovalStatus(record));

const isPending = record => getApprovalStatus(record) === "pending";

const isApproved = record => getApprovalStatus(record) === "approved";

const isRejected = record => getApprovalStatus(record) === "rejected";

const isManifestReviewed = manifest =>
  isReviewed({ approval_manifest: manifest });

const isManifestPending = manifest =>
  isPending({ approval_manifest: manifest });

const isManifestApproved = manifest =>
  isApproved({ approval_manifest: manifest });

const isManifestRejected = manifest =>
  isRejected({ approval_manifest: manifest });

module.exports = {
  hasApprovals,
  isUserAnApprover,
  isUserACurrentApprover,
  getUserAsApprover,
  getApprovalStatus,
  getCurrentApprovers,
  isReviewed,
  isPending,
  isApproved,
  isRejected,
  // handle raw manifest
  isManifestReviewed,
  isManifestApproved,
  isManifestPending,
  isManifestRejected
};
